import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _uniqueId from "lodash/uniqueId";
import _map from "lodash/map";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { campusApiClient } from '@datacamp/campus-integration';
import { ADD_ERROR_EXPLANATION_FEEDBACK, HIDE_COMPLETION_PANE, SET_HINT_SHOW, SET_RATING_STATUS, SHOW_SCT, TAKE_HINT, TAKE_SOLUTION } from './types';
export const hideCompletionPane = exerciseId => ({
  exerciseId,
  type: HIDE_COMPLETION_PANE
});
export const showSCTs = _ref => {
  let {
    exerciseId,
    isLoggedIn,
    newOutputs
  } = _ref;
  return {
    exerciseId,
    isLoggedIn,
    newOutputs: _map(newOutputs, output => _objectSpread(_objectSpread({}, output), {}, {
      messageId: _uniqueId()
    })),
    type: SHOW_SCT
  };
};
export const takeHint = _ref2 => {
  let {
    environment,
    exerciseId,
    isLoggedIn,
    message,
    onError,
    xpCost
  } = _ref2;
  return async dispatch => {
    if (isLoggedIn) {
      campusApiClient(environment).getHint(exerciseId).catch(onError);
    }
    dispatch({
      exerciseId,
      isLoggedIn,
      message,
      messageId: _uniqueId(),
      type: TAKE_HINT,
      xpCost
    });
  };
};
export const setHintShown = _ref3 => {
  let {
    exerciseId,
    hintShown
  } = _ref3;
  return async dispatch => {
    dispatch({
      exerciseId,
      hintShown,
      type: SET_HINT_SHOW
    });
  };
};
const setRatingStatus = (messageId, ratingStatus) => ({
  messageId,
  ratingStatus,
  type: SET_RATING_STATUS
});
export const rateFeedback = _ref4 => {
  let {
    environment,
    exerciseId,
    feedbackMessage,
    feedbackMessageId,
    isUseful,
    onError,
    userFeedback
  } = _ref4;
  return async dispatch => {
    if (feedbackMessageId === undefined) {
      return;
    }
    dispatch(setRatingStatus(feedbackMessageId, 'SAVING'));
    try {
      await campusApiClient(environment).rateFeedback({
        exerciseId,
        // @ts-expect-error body is not guaranteed to exist on feedbackMessage.
        extraInfo: feedbackMessage.body,
        rating: isUseful ? 5 : 1,
        ratingType: feedbackMessage.messageType === 'HINT' ? 'hint' : 'sct',
        userFeedback
      });
      dispatch(setRatingStatus(feedbackMessageId, 'SAVED'));
    } catch (e) {
      // @ts-expect-error fix later
      onError(e);
      dispatch(setRatingStatus(feedbackMessageId, 'ERROR'));
    }
  };
};
export const takeSolution = _ref5 => {
  let {
    environment,
    exerciseId,
    isLoggedIn,
    message,
    onError,
    solutionInstructions,
    xpCost
  } = _ref5;
  return async dispatch => {
    if (isLoggedIn) {
      campusApiClient(environment).getSolution(exerciseId).catch(onError);
    }
    dispatch({
      exerciseId,
      message,
      messageId: TAKE_SOLUTION,
      solutionInstructions,
      type: TAKE_SOLUTION,
      xpCost
    });
  };
};
export const addErrorExplanationFeedback = _ref6 => {
  let {
    aiAssistantProps,
    body,
    exerciseId,
    title
  } = _ref6;
  return async dispatch => dispatch({
    aiAssistantProps,
    body,
    exerciseId,
    messageId: ADD_ERROR_EXPLANATION_FEEDBACK,
    title,
    type: ADD_ERROR_EXPLANATION_FEEDBACK
  });
};